import type Web3 from 'web3';

import config from '../config';

export default (typeof window !== 'undefined'
  ? new (require('web3/dist/web3.min'))(config.web3.chain.rpcUrl)
  : null) as Web3;
